import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, ResponseContentType} from '@angular/http';
import {UserStorageService} from './authentication/user-storage.service';
import * as fileSaver from 'file-saver';


@Injectable()
export class DownloadService {

  constructor(private http: Http, private userStorage: UserStorageService) {
  }

  download(url: string, filename, mimeType: string): void {
    this.http.get(url, this.getOptions()).subscribe(
      (response) => { // download file
        let blob = new Blob([response.blob()], {type: mimeType});
        fileSaver.saveAs(blob, filename);
      });
  }

  private getOptions() {
    if (this.userStorage.oauthToken != null) {
      let headers = new Headers({
        "Authorization": "Bearer " + this.userStorage.oauthToken.access_token,
      });
      return new RequestOptions({headers: headers, responseType: ResponseContentType.Blob});
    }
    return null;
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/services/download-service.service.ts